import styled from 'styled-components/macro';
import { variables } from 'theme/variables';
import { Row, Col } from '@zendeskgarden/react-grid';
const {
  media_md,
  media_sm,
  custom_blue
} = variables;

export const ItemCol = styled(Col)`
  margin-bottom: 40px;
  @media ${media_md} {
    padding: 0px 30px;
    margin-bottom: 60px;
  }
  &:last-child {
    margin-bottom: 0;
  }
`

export const ItemRow = styled(Row)`
  ${props => props.activeService ? `margin-top: 0px`: 'margin-top: 50px'};
  @media ${media_sm} {
    
  }
  @media ${media_md} {
    margin-right: -30px;
    margin-left: -30px;
    margin-top: 0px;
  }
`

export const NavList = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`

export const NavItem = styled.div`
  padding: 0 20px 0 0;
  margin: 7px 0;
  a {
    font-size: 14px !important;
    color: ${custom_blue} !important;
    padding: 6px 10px;
    text-transform: uppercase;
    border: 1px solid rgba(52, 100, 230, 0.14);
    display: block;
    border-radius: 2px;
    transition: all 0.3s ease;
    &:hover {
      background-color: rgba(52, 100, 230, 0.14);
      color: ${custom_blue} !important;
    }
    &.active-content-link {
      background: ${custom_blue} !important;
      color: #fff !important;
    }
  }
`
